var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media my-1"},[_c('img',{staticClass:"feature-icon d-flex align-self-center",attrs:{"src":_vm.feature.icon}}),_vm._v(" "),_c('div',{staticClass:"media-body align-self-center text-left pl-2"},[_vm._v("\n        "+_vm._s(_vm.feature.name)+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ee52ab0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeaturePreview.vue
// module id = XakC
// module chunks = 1